import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/servicios/api.service';

interface RedSocial {
  idRedSocial: number;
  nombre: string;
  enlace: string;
}

class RedSocial implements RedSocial { }

@Component({
  selector: 'app-app-social-links',
  templateUrl: './app-social-links.component.html',
  styleUrls: ['./app-social-links.component.scss']

})
export class AppSocialLinksComponent implements OnInit {
  public redesSociales: RedSocial[] = [];
  constructor(private _api: ApiService) { }

  ngOnInit() {
    this.obtenerEnlacesRedesSociales();
  }

  private obtenerEnlacesRedesSociales() {
    this._api.get('enlacesRedesSociales').subscribe((enlacesResponse: Response) => {
      this.separarEnlaces(this._api.reader.read(enlacesResponse, []));
    })
  }

  private separarEnlaces(arregloEnlaces: RedSocial[]) {
    arregloEnlaces.forEach((redSocial: RedSocial) => {
      this.redesSociales[redSocial.nombre] = redSocial.enlace;
    })
  }

  public abrirEnlace(nombreRed: string) {
    if (nombreRed) {
      if (this.redesSociales[nombreRed]) {
        window.open(this.redesSociales[nombreRed], '_blank');
      }
    }
  }
}
